import { BuyerProfileUi } from '@/components/Buyer/BuyerProfile/BuyerProfileUi';
import { PaymentDataUi } from '@/components/Buyer/BuyerProfile/PaymentAndFiscalData/PaymentData/PaymentDataUi';
import { BuyerDetailsResponse } from '@/data/api/model/buyers/BuyersDto';

export function buyerDetailsResponseToPaymentDataUi(
  input: BuyerDetailsResponse
): PaymentDataUi {
  return {
    enableAllPaymentMethods: input.is_trusted_user ?? false,
  };
}

export function buyerDetailsResponseToBuyerProfileUi(
  details: BuyerDetailsResponse
): BuyerProfileUi {
  return {
    title: details.name ?? '',
    moreActions: [
      {
        label: 'Seleccionar KAM',
        variant: 'text',
      },
    ],
    assignKamOpen: false,
  };
}
